import React from "react";
import "./RoadTrip.css";
import CoastalHighwayDrive from "../../assets/CoastalHighwayDrive.png";
import MountainPassAdventure from "../../assets/MountainPassAdventure.png";
import DesertExplorationJourney from "../../assets/DesertExplorationJourney.png";
import CountrysideScenicRoute from "../../assets/CountrysideScenicRoute.png";
import ForestTrailDrive from "../../assets/ForestTrailDrive.png";
import LakeviewRoadEscape from "../../assets/LakeviewRoadEscape.png";
import { useNavigate } from "react-router-dom";
const roadTrips = [
  {
    title: "Coastal Highway Drive",
    image: CoastalHighwayDrive,
    description:
      "Embark on a scenic coastal highway road trip filled with ocean views and refreshing sea breeze. Stop at charming towns, enjoy local seafood, and capture stunning sunset moments along the journey.",
    link: "/tour-package-data",
  },
  {
    title: "Mountain Pass Adventure",
    image: MountainPassAdventure,
    description:
      "Drive through winding mountain passes surrounded by breathtaking landscapes and cool fresh air. Discover hidden viewpoints, peaceful valleys, and thrilling routes that make this road trip unforgettable.",
    link: "/tour-package-data",
  },
  {
    title: "Desert Exploration Journey",
    image: DesertExplorationJourney,
    description:
      "Experience a unique desert road trip across vast golden landscapes and endless horizons. Enjoy cultural villages, scenic sunsets, and adventurous stops while exploring untouched beauty on the open road.",
    link: "/tour-package-data",
  },
  {
    title: "Countryside Scenic Route",
    image: CountrysideScenicRoute,
    description:
      "Enjoy a relaxing countryside road trip through green fields and peaceful villages. Stop at local markets, taste regional cuisine, and admire charming landscapes for a refreshing escape.",
    link: "/tour-package-data",
  },
  {
    title: "Forest Trail Drive",
    image: ForestTrailDrive,
    description:
      "Take a thrilling drive through dense forests surrounded by tall trees and natural beauty. Experience wildlife sightings, scenic stops, and peaceful moments during this exciting road adventure.",
    link: "/tour-package-data",
  },
  {
    title: "Lakeview Road Escape",
    image: LakeviewRoadEscape,
    description:
      "Travel along serene lake routes offering stunning reflections and calm waters. Enjoy picnic breaks, photography stops, and relaxing moments while exploring picturesque landscapes by road.",
    link: "/tour-package-data",
  },
];

const RoadTrip = () => {
  const navigate=useNavigate()
  return (
    <div className="roadtrip-container">
      <h2 className="roadtrip-title">Road Trip Packages</h2>

      <div className="roadtrip-grid">
        {roadTrips.map((trip, index) => (
          <div
            className="roadtrip-card"
            key={index}
            onClick={() =>
              navigate(trip.link, {
                state: { title: trip.title },
              })
            }
          >
            <img src={trip.image} alt={trip.title} />
            <div className="roadtrip-content">
              <h3>{trip.title}</h3>
              <p>{trip.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoadTrip;
